module.exports = __webpack_public_path__ + "img/IND-B-1-II.424f3776.png";